<mat-toolbar class="header header-regular">
  <div class="container">
    <!-- Mobile menu toggle button -->
    @if (!isExpanded()?.matches) {
      <button 
        mat-icon-button 
        (click)="toggleMobileNav()" 
        class="sidenav-toggle-btn"
        [attr.aria-label]="sidenavOpened() ? 'Hide loan list' : 'Show loan list'">
        <mat-icon>{{ sidenavOpened() ? 'close' : 'list' }}</mat-icon>
      </button>
    }

    <a class="navbar-brand" routerLink="/">
      <img class="header-logo" src="assets/images/header-logo-text.svg" alt="Transend Logo">
    </a>

    <!-- <app-navbar></app-navbar> -->

    <!-- TODO: Migrate to an "account-info" component. -->
    <div class="account-wrapper">
      <span class="account-welcome">
        <span class="account-name">{{username | titlecase }}</span>
      </span>

      <button mat-icon-button [matMenuTriggerFor]="accountMenu" aria-label="Account menu">
        <mat-icon>account_circle</mat-icon>
      </button>
      <mat-menu #accountMenu="matMenu">
        <button mat-menu-item (click)="logout()" aria-label="Logout">
          <mat-icon>logout</mat-icon>
          <span>Logout</span>
        </button>
          <button mat-menu-item [routerLink]="['/account', 'change-password']" aria-label="Change Password">
          <mat-icon>key</mat-icon>
          <span>Change Password</span>
        </button>
      </mat-menu>
    </div>
  </div>
</mat-toolbar>
